import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardActions, CardHeader, IconButton, Button, Menu, MenuItem, Modal, Box, Divider, FormControl, Select, InputLabel, TextField, Typography, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Neighbourhood from '../neighbourhood/Neighbourhood';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import debounce from 'lodash.debounce';


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Outgoing-waste' }} />
        </GridToolbarContainer>
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    community_pickup_group_id: string;
    pageSize: number;
    anchorEl: any;
    filter: any;
    pickup_status: any;
    groupPickups: any;
    showLoader: boolean;
    rowCount: any;
    /**Add waste by Vehicle Form Data */
}

class GroupPickups extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            community_pickup_group_id: this.props.match.params.id,
            pageSize: 20,
            anchorEl: null,
            filter: '',
            pickup_status: '',
            groupPickups: [],
            showLoader: false,
            rowCount: 0,
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        console.log("props", this.props);
        this.fetchGroupPickups();
    }

    public fetchGroupPickups(page: number = 0, limit: number = this.state.pageSize) {
        this.setState({ showLoader: true });
        let body = {
            "community_pickup_group_id": this.state.community_pickup_group_id,
            "filter": this.state.filter,
            "hierarchies": this.props.user.selectedHierarchyIds,
            "ignore_hierarchy": true,
            "limit": limit,
            "page": page + 1,
            "pickup_status": ((this.state.pickup_status == "all") ? '' : this.state.pickup_status)
        }
        axios.post('filterPickups', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                this.setState({ showLoader: false, rowCount: response.data.data.total });
                let data = response.data.data.data;
                let groupPickupData: any = []
                data.map((el: any) => {
                    groupPickupData.push({
                        "id": el.id,
                        "date_slot": el.pickup_date,
                        "pickup_slot": el.pickup_slot,
                        "name": el.cust_name,
                        "mobile": el.cust_phone,
                        "house_no": el.cust_hno,
                        "agent": el.agent_name,
                        "pickup_status": el.pickup_status,
                        "payment_status": el.payment_status,
                        "weight": el.weight?.total,
                        "comment": "",
                        "rescheduled_to": el.rescheduled_to
                    })
                })
                this.setState({ groupPickups: groupPickupData });
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchGroupPickups(page, limit);
    }, 800);

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const renderMaskedCell = (params: GridCellParams) => (
            <Box
                component="span"
                sx={isUatEnvironment ? {
                    filter: 'blur(4px)',
                    opacity: 0.5,
                    userSelect: 'none',
                } : undefined}
            >
                {params.value}
            </Box>
        );


        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <Link to={`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`} style={{ textDecoration: 'none' }}>{params.row.id}<OpenInNewOutlinedIcon sx={{ verticalAlign: "middle" }} /></Link>
                )
            },
            {
                headerName: "Date(Slot)",
                field: "date_slot",
                width: 180,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{ cursor: 'pointer' }}>{params.row.date_slot + " (" + params.row.pickup_slot + ")"}</Typography>
                )
            },
            {
                headerName: "Name",
                field: "name",
                width: 150,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Mobile",
                field: "mobile",
                width: 120,
                renderCell: renderMaskedCell
            },
            {
                headerName: "House No.",
                field: "house_no",
                width: 100,
                renderCell: renderMaskedCell
            },
            {
                headerName: "Agent",
                field: "agent",
                width: 120
            },
            {
                headerName: "Status",
                field: "pickup_status",
                width: 220,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{ cursor: 'pointer' }} sx={{ textTransform: 'capitalize' }} className={(params.row.pickup_status == 'pending') ? 'statusTextError' : 'statusTextSuccess'}>{params.row.pickup_status}
                        {
                            (params.row.rescheduled_to > 0) &&
                            <Link to={`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`} style={{ fontWeight: '700' }}>(#0{params.row.rescheduled_to})</Link>
                        }
                    </Typography>
                )
            },
            {
                headerName: "Payment",
                field: "payment_status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.payment_status == 'pending') ? 'statusTextError' : 'statusTextSuccess'}>{params.row.payment_status}</Typography>
                )
            },
            {
                headerName: "Total kg",
                field: "weight",
                width: 80,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{ cursor: 'pointer' }}>{params.row.weight == null ? 0 : params.row.weight}</Typography>
                )
            },
            {
                headerName: "Comment",
                field: "comment",
                width: 200
            },

        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={7} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Group Pickups")}</Typography>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Pickup Status")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.pickup_status}
                                                    onChange={(e: any) => this.setState({ pickup_status: e.target.value }, () => this.fetchGroupPickups())}
                                                    displayEmpty
                                                    label={t("Pickup Status")}
                                                >
                                                    <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                    <MenuItem key={'Collected'} value={'collected'}>{t("Collected")}</MenuItem>
                                                    <MenuItem key={'Pending'} value={'pending'}>{t("Pending")}</MenuItem>
                                                    <MenuItem key={'Complete'} value={'complete'}>{t("Complete")}</MenuItem>
                                                    <MenuItem key={'Cancelled'} value={'cancelled'}>{t("Cancelled")}</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                            />
                            {/* <CardActions>
                                <Button variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddWaste: true })}><Add /> Add Outgoing Waste</Button>
                            </CardActions> */}
                            <CardContent>
                                <DataGrid
                                    aria-label="Outgoing Waste List"
                                    columns={columns}
                                    rows={this.state.groupPickups}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchGroupPickups(page)}
                                    onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchGroupPickups(0, newPageSize) }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{height: 500}}
                                    components={{
                                        // MoreActionsIcon: EditOutlined,
                                        // Toolbar: CustomToolbar
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/operations/batch-pickups/group-pickups/pickup-details/' + params.id)
                                        // window.open(`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`, '_blank', 'noreferrer');
                                    }}
                                    // componentsProps={{ toolbar: { csvOptions: { fileName: 'Tickets-list' } } }}
                                    paginationMode="server"
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(GroupPickups))
